module.exports = __webpack_public_path__ + "img/consult.2f22aaf5.png";